import {  WebSocketSubject  } from './WebSocketSubject';

export const webSocket = WebSocketSubject.create;


// WEBPACK FOOTER //
// ../../../src/observable/dom/webSocket.ts